import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { addNewPropertyFilter, removeNewPropertyFilter, fetchSearchResultsIfNotBusy } from '../actions/search'
import { translate } from '../../modules/helper-functions'
import Toggle from './Toggle'

const Container = styled.div`
  width: 100%;
  padding-top: 25px;
  font-size: 14px;
`

/**
 * NewPropertyFilter component
 */
class NewPropertyFilter extends Component {
  /**
   * @constructor
   * @param {any} props
   */
  constructor( props ) {
    super( props )

    this.handleChange = this.handleChange.bind( this )
  }

  /**
   * Function handles the component changes by
   * either adding or removing the new property filter.
   *
   */
  handleChange() {
    const { addFilter, removeFilter, newProperty } = this.props
    if ( newProperty ) {
      removeFilter()
    } else {
      addFilter()
    }
  }

  /**
   * Render method.
   */
  render() {
    const { translations, newProperty } = this.props
    return (
      <Container>
        <Toggle
          id={'newPropertyFilter'}
          handleChange={this.handleChange}
          checked={newProperty}
          label={translate( translations, 'Only new properties' )}
          />
      </Container>
    )
  }
}

NewPropertyFilter.propTypes = {
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  newProperty: PropTypes.bool.isRequired
}

/**
 * Add dispatch functions to components props.
 *
 * @param {function} dispatch
 * @return {object}
 */
const mapDispatchToProps = ( dispatch ) => {
  return {
    addFilter: () => {
      dispatch( addNewPropertyFilter())
      dispatch( fetchSearchResultsIfNotBusy())
    },
    removeFilter: () => {
      dispatch( removeNewPropertyFilter())
      dispatch( fetchSearchResultsIfNotBusy())
    }
  }
}

/**
 * Map the redux state to component props.
 *
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  translations: state.translations,
  newProperty: state.search.filters.new_property
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)( NewPropertyFilter )
